import "./login-style.css";
import { loginEmployee } from "../api/loginEmployee.js";

<let/email="" />
<let/isLoggingIn = false>

<let/confirmLogin = async (email: string) => {
  console.log("login button clicked");
  if (!email) {
    alert("Enter an email first.");
    return;
  }

  console.log(`recieved email: ${email}`);
  
  try {
    const result = await loginEmployee(email);
    console.log("API call finished");
    if (result.success) {
      // sessionStorage.email used for otp-verification page to remember email input.
      sessionStorage.setItem('email', email);
      window.location.href = "/otp-verification";
    } else {
      alert(result.message);
    }

  } catch (err) {
    console.error(err);
  }
}/>


<body>
<div class="container">
    <h1>
      SALN APP Login
    </h1>

    <input
      type="text"
      class="enterEmail"
      placeholder="Email"
      onInput(event) {
        email = event.target.value.trim();
      }
    />
    <br>
    <button class="confirmLogin" onClick() {
      if (isLoggingIn) {
        console.log("error: button disabled");
        return;
      }
      isLoggingIn = true;
      console.log("logging in");
      confirmLogin(email).finally(() => {
        isLoggingIn = false;
      });
    }>
      Log in with Email
    </button>
    <br>
</div>
</body>